import styled from "styled-components"
import { Box } from "@xingternal/winery-ui/lib/Box"
import { Panel } from "@xingternal/winery-ui/lib/Panel"
import { themeGet } from "@styled-system/theme-get"

const ContentWrapper = styled(Box)`
  width: 1008px;
  max-width: 100%;

  & > ${Panel} {
    margin-top: ${themeGet("space.5")};
  }
`

export default ContentWrapper
